import React, { Fragment as F } from 'react'
import c from 'classnames'
import get from 'lodash/get'
import { connect } from 'react-redux'

import Icon from 'discada/dist/Icon'
import Tag from 'discada/dist/Tag'
import Loading from 'discada/dist/Loading'

import { money, moneyShort } from 'utils'
import Bank from 'components/Quote/Bank'
import Payment from 'components/Quote/Payment'

import { INTENTS } from 'reducers/quoteReducers'
import { setMode } from 'actions/quoteActions'
import { getIsUsedCar } from 'selectors/inventorySelectors'
import { addToPageState, toggleQueryValue } from 'actions/pageStateActions'

import {
  showPersonalizeMessage,
  shouldShowPrice,
  doesQuoteHaveFees,
  doesQuoteHaveTaxes,
  explodeProgramKey,
  getBestProgramKey,
  getProgramByKey,
  getIsLoading,
  getIsGettingPrograms,
  getCashDealTotal,
  isProgramExpired,
} from 'selectors/quoteSelectors'

import { isSqueezeJacketOpen } from 'selectors/appStatusSelectors'

import { getEntity } from 'selectors/entitySelectors'

import './PricingCard.scss'

export function CardTagPreso({
  mode,
  showRange,
  addToPageState,
  showPrice,
  hasTaxes,
  hasFees,
}) {
  let quoteAction =
    mode === 'cash' && !showPrice ? INTENTS.getCashPrice : INTENTS.getOTD

  return !showRange ? (
    hasFees || hasTaxes ? (
      <Tag className="otd">
        <strong>
          {[hasTaxes ? 'Taxes' : null, hasFees ? 'Fees' : null]
            .filter(x => x)
            .join(' & ')}{' '}
          Included!
        </strong>
      </Tag>
    ) : (
      <Tag className="extra">Fees &amp; Taxes not included</Tag>
    )
  ) : (
    <Tag
      className="getOTD"
      onClick={() => addToPageState({ mode, quoteAction }, null, true)}
    >
      See <strong>PERSONALIZED PAYMENTS</strong> NOW!
    </Tag>
  )
}

export const HEADERS = {
    loan: () => <span>ESTIMATED LOAN</span>,
    lease: () => <span>ESTIMATED LEASE</span>,
    cash: (_, showRange, isUsed, p, s, showPrice) => {
      let nonOtdLabel = isUsed || !showPrice ? 'PRICE' : 'MSRP'

      return (
        <span>{showRange ? nonOtdLabel : 'Pay cash or write a check'}</span>
      )
    },
  },
  MINI_HEADERS = {
    loan: (selected, showRange, _, { term }, showParams) => (
      <span>{showParams && term && `${term}mo`} LOAN</span>
    ),
    lease: (selected, showRange, _, { term }, showParams) => (
      <span>{showParams && term && `${term}mo`} LEASE</span>
    ),
    cash: (selected, showRange, isUsed, p, s, showPrice) => {
      let nonOtdLabel = isUsed || !showPrice ? 'PRICE' : 'MSRP'

      return <span>{showRange ? nonOtdLabel : 'CASH'}</span>
    },
  },
  CONTENTS = {
    loan: ({ expired, Lender, term, down, sellingPrice }, op) => (
      <span>
        for {term} months with {moneyShort(down)} down
        <span className="selling-price">
          Selling Price {money(sellingPrice)}
        </span>
        <strong className="bank">
          <Bank name={Lender} />
        </strong>
        <CardTag {...op} />
        {expired && (
          <strong className="expiration">
            <Icon icon="asterisk" />
          </strong>
        )}
      </span>
    ),
    lease: ({ expired, Lender, term, down, sellingPrice }, op) => (
      <span>
        for {term} months with {money(down)} down
        <span className="selling-price">
          Lease Selling Price {money(sellingPrice)}
        </span>
        <strong className="bank">
          <Bank name={Lender} />
        </strong>
        <CardTag {...op} />
        {expired && (
          <strong className="expiration">
            <Icon icon="asterisk" />
          </strong>
        )}
      </span>
    ),
    cash: (_, op) => <CardTag {...op} />,
  },
  SelectedFooter = ({ mode }) => (
    <span className="card-footer-item">
      <span>
        <Icon icon="clipboard-check" /> This is{' '}
        <em>
          <strong>YOUR</strong>
        </em>{' '}
        {mode === 'cash' ? 'Price' : 'Payment'}!
      </span>
    </span>
  )

export class PricingCard extends React.Component {
  render() {
    let {
        className,
        selected,
        mini,
        header,
        content,
        mode,
        onClick = () => {},
        isSpecial,
        isLoading,
        toggle,
        setMode,
        autoHide,
        forceHide,
        payment,
        vehicleId,
        quoteId,
        showRange,
        showPrice,
        raw,
        short,
        isValid,
        ignoreKnown,
      } = this.props,
      paymentComp = (
        <Payment
          range={showRange}
          vehicleId={vehicleId}
          quoteId={quoteId}
          mode={mode}
          payment={payment}
          fallback={mini ? '--' : 'Contact Us!'}
          raw={raw}
          short={short}
          ignoreKnown={ignoreKnown}
        />
      )

    if (autoHide && (!isValid || payment <= 0)) return null
    if (forceHide) return null

    if (mode === 'cash' && !showPrice) {
      paymentComp = mini ? (
        <span className="locked-price mini">
          <strong>
            <Icon icon="lock-alt" className="locked-icon" />
          </strong>{' '}
          <span>Unlock</span>
        </span>
      ) : (
        <span className="locked-price">
          <strong>
            <Icon icon="lock-alt" className="locked-icon" />
          </strong>{' '}
          <p>Unlock Your Price!</p>
        </span>
      )
    }

    return (
      <div
        className={c(
          'pricing-card',
          'card',
          `pricing-card-${mode}`,
          className,
          {
            selected: selected,
            'not-selected': !selected,
            'pricing-card-mini': mini,
            'pricing-card-special': isSpecial,
            'pricing-card-loading': isLoading,
            'no-program': !isValid,
          },
        )}
        onClick={e => {
          toggle && setMode(this.props)
          onClick(e)
        }}
      >
        <div className="your-banner">{header}</div>

        <div className="card-content">
          {isLoading ? (
            <Loading />
          ) : (
            <F>
              <div className="content">
                <div className="title is-spaced">{paymentComp}</div>
                {!mini && <div className="subtitle">{content}</div>}
              </div>
            </F>
          )}
        </div>
      </div>
    )
  }
}
function mapStateToProps(state, op) {
  let vId = op.vehicleId || op.id,
    programKey =
      op.programKey ||
      getBestProgramKey(state, op.vehicleId, op.quoteId, op.mode),
    program = getProgramByKey(state, op.vehicleId, op.quoteId, programKey),
    explodedKey = explodeProgramKey(programKey),
    mode = explodedKey.mode || op.mode,
    showRange = showPersonalizeMessage(state) || op.showRange,
    payment =
      op.payment ||
      (mode === 'cash'
        ? getCashDealTotal(state, op.vehicleId, op.quoteId)
        : get(program, 'Payment', 0)),
    isUsed = getIsUsedCar(state, vId),
    hasFees = doesQuoteHaveFees(state, op.vehicleId, op.quoteId),
    hasTaxes = doesQuoteHaveTaxes(state, op.vehicleId, op.quoteId),
    sellingPrice =
      get(getEntity(state, op.vehicleId), 'sellingPrice', 0) ||
      get(getEntity(state, op.vehicleId), 'msrp', 0),
    isLoading =
      getIsLoading(state, op.vehicleId, op.quoteId) ||
      getIsGettingPrograms(state, op.vehicleId, op.quoteId) ||
      isSqueezeJacketOpen(state),
    showParams = op.showParams && !isLoading,
    showPrice = shouldShowPrice(state, op.vehicleId, op.quoteId) || op.showPrice

  return {
    isUsed,
    program,
    payment,
    isLoading,
    showRange,
    showPrice,
    hasFees,
    hasTaxes,
    autoHide: op.hasOwnProperty('autoHide') ? op.autoHide : false,
    isValid: program.isValid || op.hasOwnProperty('payment'),
    header:
      mode &&
      (op.mini ? MINI_HEADERS : HEADERS)[mode](
        op.selected,
        showRange,
        isUsed,
        program,
        showParams,
        showPrice,
      ),
    content: (CONTENTS[mode] || (() => {}))(
      {
        ...program,
        ...explodedKey,
        showRange,
        expired: isProgramExpired(
          state,
          op.vehicleId,
          op.quoteId,
          op.mode,
          program,
        ),
        sellingPrice,
      },
      op,
    ),
    isSpecial: program.SpecialStandard,
    ...op,
  }
}

export const CardTag = connect(
  mapStateToProps,
  {
    setMode,
    toggleQueryValue,
    addToPageState,
  },
)(CardTagPreso)

export default connect(
  mapStateToProps,
  {
    setMode,
    toggleQueryValue,
    addToPageState,
  },
)(PricingCard)
